export const locale = {
  lang: 'en-CA',
  data: {
    TOOLBAR: {
      HISTORY: 'Historic',
      HISTORIES: 'Browsing histories',
      NO_HISTORY: 'No history',
      FULLSCREEN: 'Fullscreen',
      MY_PROFILE: 'My Profile',
      DARKMODE: 'Dark Mode',
      LIGTHMODE: 'Light Mode',
      ORGANIZATION: 'Organization',
      LOGOUT: 'Logout',
      RESET_TABLE: 'Reset',
      SUGGEST_HINT:
        'Up/Down arrows to choose, Enter to open, Enter with no choice = all results',
      CREATE_EMPLOYEE: 'Create an employee',
      CREATE_PRODUCT: 'Create a product',
      CREATE_PRODUCT_COMBO: 'Create a combo',
      CREATE_PRODUCT_COMBO_DYNAMIC: 'Create a dynamic combo',
      CREATE_ORDER: 'Create an order',
      CREATE_PLACE: 'Create a place',
      CREATE_ENTERPRISE: 'Create an enterprise',
      CREATE_CLIENT: 'Create a client',
      CREATE_MATERIAL: 'Create an equipment',
      CREATE_CLIENT_ENTERPRISE: 'Create client and enterprise',
      CREATE_MATERIAL_COMBO: 'Create an equipment combo',
      SETTINGS: 'Settings',
      CREATE_PROPOSAL: 'Create a proposal',
      CATERER: 'Caterer',
      SHOP: 'Order online',
      CREATE_CONGRES: 'Create a congress',
      OPEN_NEW_TAB: 'Open in new tab',
      QUICK_ORDER: 'Quick order',
      NEW_PICKUP: 'New Pickup [Beta]',
      NOTIFICATIONS: 'Notifications',
      NOTIFICATIONS_NONE: 'Notifications, none unread',
      NOTIFICATIONS_ONE: 'Notifications, 1 unread',
      NOTIFICATIONS_MANY: 'Notifications, {{count}} unread',
      PREFERENCES: 'Preferences',
    },
  },
};
